import React from 'react';

import { useNavigate } from 'react-router-dom';

/**
 * @property {string}  buttonClass - サイズなどのクラス指定
 * @property {string}  id - ボタンID default:back
 * @property {string}  label - ボタンラベル default:戻る
 * @property {Function}  onclickEvent - default:前画面へ戻る
 */
type Props = {
  buttonClass?: string;
  id?: string;
  label?: string;
  onclickEvent?: (e: React.MouseEvent<HTMLElement>) => void;
};

export const ButtonBack = (props: Props) => {
  const navigate = useNavigate();

  const { buttonClass = '', id = 'back', label = '戻る', onclickEvent = () => navigate(-1) } = props;
  const className =
    'bg-contents hover:text-main md:text-sub text-main font-bold md:w-[170px] h-[54px] w-[310px] rounded-[27px] mb-[60px] md:mb-10' +
    buttonClass;

  return (
    <button id={id} className={className} onClick={(e) => onclickEvent(e)} type="button">
      {label}
    </button>
  );
};
